import cn from "classnames";
import { FC, useMemo } from "react";
import { useSetGameBoxType } from "../../../../hoc/useSetGameBoxType";
import MissionTitleAndDescriptionWidget from "../../../MissionTitleAndDescriptionWidget";
import "./styles.scss";

interface BonusCategoriesProps {
  tag: string;
  selectedTag: string;
  isActive: boolean;
  activeMissionsCount: number;
}

const BonusCategories: FC<BonusCategoriesProps> = ({
  tag,
  selectedTag,
  isActive,
  activeMissionsCount,
}) => {
  const setGameBoxType = useSetGameBoxType();
  const tabClickAudio = useMemo(() => new Audio('static/sounds/click.mp3'), []);

  const handleSelect = () => {
    if (isActive) {
      setGameBoxType(tag);
      tabClickAudio.currentTime = 0;
      tabClickAudio.play().catch(console.error)
      window.parent.postMessage(
        {
          type: "GAMEBOX_CATEGORY_CHANGE_TRIGGERED",
          data: { navigation: "vertical" },
        },
        "*"
      );
    }
  };

  const classes = cn("bonus__tag", {
    inactive: !isActive,
    selected: tag === selectedTag,
  });

  return (
    <>
      <div className={classes} onClick={handleSelect}>
        <MissionTitleAndDescriptionWidget tag={tag} />
        {activeMissionsCount ? (
          <div className="bonus__tag__count">
            <span>{activeMissionsCount}</span>
          </div>
        ) : null}
      </div>
    </>
  );
};

export default BonusCategories;
